module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('login', {
    attrs: {
      "showConfirmedAccount": _vm.showConfirmedAccount
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-608fad36"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Confirmation.vue
// module id = 2281
// module chunks = 0